import { Component, OnInit, Input } from '@angular/core';
import { ServiceTypeEnum, XpressDeliveryStatus, RiderVehicleTypeEnum } from 'app/models';
import { ActiveOrdersComponent } from 'app/components/active-orders';

@Component({
    selector: 'active-orders-filter',
    templateUrl: './active-orders-filter.component.html',
    styleUrls: ['./active-orders-filter.component.scss']
})
export class ActiveOrdersFilterComponent implements OnInit {
    constructor() { }
    @Input()
    public activeOrdersComponent!: ActiveOrdersComponent;

    public minMaxRangeValue: number[] = [];

    public minRangeValue: number = 0;
    @Input()
    set _minRangeValue(min: number) {
        this.minMaxRangeValue[0] = min;
        this.minRangeValue = min;
    }

    public maxRangeValue: number = 0;
    @Input()
    set _maxRangeValue(max: number) {
        this.minMaxRangeValue[1] = max;
        this.maxRangeValue = max;
    }

    public activeServiceTypeId = ServiceTypeEnum.Ride;

    public riderVehicleTypes = RiderVehicleTypeEnum;
    public deliveryStatuses = XpressDeliveryStatus;

    public selectedRiderVehicleTypes: RiderVehicleTypeEnum[] = [];
    public selectedDeliveryStatuses: XpressDeliveryStatus[] = [];

    ngOnInit(): void {
    }

    public uncheckServiceTypes() {
        this.selectedRiderVehicleTypes = [];
    }

    public uncheckDeliveryStatuses() {
        this.selectedDeliveryStatuses = [];
    }

    public clickFilter() {
        this.activeOrdersComponent.visibleActiveOrdersFilter = false;
        this.activeOrdersComponent.getDeliveryOrders(0, this.selectedRiderVehicleTypes, this.minMaxRangeValue, this.selectedDeliveryStatuses);
    }
}
